import { Locale as e } from "../../constants/locale.js";
import * as a from "yup";
const n = a.string().when([e.English], (r) => a.string().default((s, i) => i || r)).default(""), o = a.object({
  [e.English]: a.string().default(""),
  [e.French]: n,
  [e.Japanese]: n,
  [e.Korean]: n,
  [e.Portuguese]: n,
  [e.Russian]: n,
  [e.Thai]: n,
  [e.Filipino]: n,
  [e.Ukrainian]: n,
  [e.Vietnamese]: n,
  [e.Chinese_China]: n,
  [e.Chinese_Taiwan]: n
});
export {
  o as localizeValuesSchema
};
//# sourceMappingURL=locale.js.map
